<template>
  <div>
    <h1 class="h3 mb-3 text-gray-800">
      {{ $t("Detalhes do Acompanhamento") }}
    </h1>

    <load v-if="loading" />
    <div v-else class="row">
      <div class="col-md-12">
        <print-content>
          <table
            class="table b-table b-table-stacked-xs table-bordered table-sm bg-white"
          >
            <tbody>
              <tr>
                <td colspan="4">
                  <h4 class="text-center">Detalhes do Acompanhamento</h4>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <HeaderAcompanhamento :acompanhamento="item" class="px-0" />
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Serviço:
                  <strong>{{
                    verificarValueArray(item.servico_id, servicos)
                  }}</strong>
                </td>
                <td colspan="2">
                  Técnico de referência:
                  <strong>{{
                    verificarValueArray(item.tecnico_id, tecnicos)
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  Data de início:
                  <strong>{{ item.data_ingresso | formatDate() }}</strong>
                </td>
                <td>
                  Data Final:
                  <strong>{{ item.data_final | formatDate() }}</strong>
                </td>
                <td>
                  Data da Próxima avaliação:
                  <strong>{{ item.data_avaliacao | formatDate() }}</strong>
                </td>
                <td>
                  Periodicidade:
                  <strong>{{
                    verificarValueArray(
                      item.periodicidade,
                      $root.arrays.acompanhamento_periodicidade
                    )
                  }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  Vulnerabilidades:
                  <strong
                    class="badge badge-light mr-2"
                    v-for="(vunerabilidade, i) in item.vulnerabilidades"
                    :key="i"
                    >{{
                      vunerabilidade
                        ? verificarValueArray(vunerabilidade, vulnerabilidades)
                        : ""
                    }}</strong
                  >
                </td>
                <td colspan="2">
                  Violações de direitos:
                  <strong
                    class="badge badge-light mr-2"
                    v-for="(violencia, v) in item.violencias"
                    :key="v"
                  >
                    {{
                      violencia
                        ? verificarValueArray(violencia, violencias)
                        : ""
                    }}</strong
                  >
                </td>
              </tr>
              <tr class="no-break-inside">
                <td colspan="4">
                  Potencialidades:
                  <p v-html="item.potencialidades"></p>
                </td>
              </tr>
              <tr class="no-break-inside">
                <td colspan="4">
                  Fragilidades:
                  <p v-html="item.fragilidades"></p>
                </td>
              </tr>
              <tr class="no-break-inside">
                <td colspan="4">
                  Intervenção:
                  <p v-html="item.estrategia"></p>
                </td>
              </tr>
              <tr class="no-break-inside">
                <td colspan="4">
                  Avaliação Técnica:
                  <p v-html="item.diagnostico"></p>
                </td>
              </tr>
              <tr class="no-break-inside">
                <td colspan="4">
                  Objetivos a serem atingidos:
                  <p v-html="item.recursos_mobilizados"></p>
                </td>
              </tr>
            </tbody>
          </table>
          <print-footer
            v-if="item.responsavel.tecnico.assinatura_digital"
            :tecnico="item.responsavel.tecnico"
            class="mt-0"
            :assinatura="item.responsavel.tecnico.assinatura_digital"
            :wpp="wpp"
            :email="email"
          />
          <span
            class="mr-2"
            v-for="(tecnico, index) in item.outros_tecnicos"
            :key="index"
            v-if="outrasAssinaturas"
          >
            <print-footer
              :tecnico="tecnico"
              class="mt-0"
              :assinatura="tecnico.assinatura_digital"
            />
          </span>
        </print-content>
        <p class="text-muted">{{ app_cidade }}, {{ app_data_atual }}</p>

        <div class="row pt-4 px-0 d-flex justify-content-end no-print">
          <div class="col-auto px-2 text-right">
            <router-link
              v-if="isOwner"
              :to="`/dashboard/acompanhamento/edit/${item.id}?familia_id=${item.familia_id.id}`"
              class="btn btn-default"
            >
              <i class="mdi mdi-arrow-left" />
            </router-link>
            <router-link
              v-else
              :to="`/dashboard/acompanhamentos/${item.familia_id.id}`"
              class="btn btn-default"
            >
              <i class="mdi mdi-arrow-left" />
            </router-link>

            <a class="btn btn-sm py-1 btn-primary" @click="print()">
              <i class="mdi mdi-printer mdi-18px" />
            </a>

            <form-toggle
                grid="12"
                mt="0"
                v-model="email"
                label="Email"
            />
            <form-toggle
                grid="12"
                mt="0"
                v-model="wpp"
                label="Telefone/WhatsApp"
            />
            <form-toggle
              grid="12"
              mt="0"
              v-model="outrasAssinaturas"
              label="Assinatura Técnico (a) Participante"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderAcompanhamento from "./HeaderAcompanhamento";
export default {
  components: { HeaderAcompanhamento },
  name: "Show",
  data() {
    return {
      loading: true,
      isOwner: false,
      item: {},
      app_cidade: this.$store.state.settings.app_cidade,
      app_data_atual: this.$store.state.settings.app_data_atual,
      vulnerabilidades: [],
      violencia: [],
      tecnicos: [],
      servicos: [],
      unidades: [],
      outrasAssinaturas: false,
      email: true,
      wpp: true
    };
  },
  mounted() {
    this.getUnidades();
    this.getVulnerabilidades();
    this.getViolencias();
    this.getTecnicos();
    this.getServicos();
    this.getItem();
  },
  updated() {
    if (this.$store.state.user) {
      let user_id = this.$store.state.user.id;
      this.isOwner = user_id == this.item.user_id ? true : false;
    }
  },
  methods: {
    getItem() {
      this.loading = true;
      axios
        .get(`api/dashboard/acompanhamentos/${this.$route.params.id}`)
        .then((response) => {
          this.item = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          this.$router.push("/dashboard/familias");
        });
    },
    getVulnerabilidades() {
      axios.get(`api/dashboard/get/vulnerabilidades`).then((response) => {
        this.vulnerabilidades = response.data;
      });
    },
    getViolencias() {
      axios.get(`api/dashboard/get/violencias`).then((response) => {
        this.violencias = response.data;
      });
    },
    getServicos() {
      axios.get(`api/dashboard/acompanhamento/servicos`).then((response) => {
        this.servicos = response.data;
      });
    },
    getTecnicos() {
      axios.get(`api/dashboard/tecnicos/get`).then((response) => {
        this.tecnicos = response.data;
      });
    },
    getUnidades() {
      axios
        .get(`api/dashboard/unidades/get/externas/PLANTAO`)
        .then((response) => {
          this.unidades = response.data;
        });
    },
    verificarValueArray(value, array) {
      const result = array.filter((item) => item.id == value);
      return result[0] ? result[0].value : "";
    },
  },
};
</script>

<style scoped>
.no-break-inside {
  page-break-inside: inherit !important;
}
</style>
